export default () => ({
    swiper: null,
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.blogCarousel, {
            slidesPerView: 4,
            spaceBetween: 6,
            pagination: false,
            loop: true,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                    navigation: false,
                },
                567: {
                    slidesPerView: 1.5,
                },
                767: {
                    slidesPerView: 2.25,
                },
                1023: {
                    slidesPerView: 2.5,
                    spaceBetween: 12,
                },
                1279: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
    },
});
